import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/site/PageHero";
import DestinationCard from "@/components/site/DestinationCard";
import { Reveal } from "@/components/motion";
import { getDestinations } from "@/lib/api";

export default function Destinations() {
  const [all, setAll] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { getDestinations().then(setAll).catch(() => {}); }, []);

  const filtered = all.filter((d) => d.name.toLowerCase().includes(q.toLowerCase()) || (d.region || "").toLowerCase().includes(q.toLowerCase()));

  return (
    <>
      <Seo title="India Destinations | Legacy India Travel" description="Explore India's most beautiful destinations — Delhi, Agra, Jaipur, Kashmir, Kerala, Goa, Ladakh, Varanasi and many more. Plan your India journey." />
      <PageHero title="Destinations of India" subtitle="From Himalayan lakes to tropical shores — discover the places that will define your journey." image="https://images.pexels.com/photos/35255985/pexels-photo-35255985.jpeg?auto=compress&cs=tinysrgb&w=1600" crumbs={[{ label: "Destinations" }]} />

      <section className="py-14 sm:py-20 bg-[#faf8f5]">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <div className="flex justify-end mb-10">
            <div className="flex items-center gap-2 border border-[#d4af37]/40 bg-white px-4 py-2.5 min-w-[280px]">
              <Search className="w-4 h-4 text-[#7c1d1d]" />
              <input data-testid="destination-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search destinations..." className="flex-1 bg-transparent outline-none text-sm text-[#3b1a1a]" />
            </div>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="destinations-grid">
            {filtered.map((d, i) => (
              <Reveal key={d.id} delay={(i % 4) * 0.05}>
                <DestinationCard dest={d} className="w-full" />
              </Reveal>
            ))}
          </div>
          {filtered.length === 0 && <div className="text-center py-16 text-[#5a4b4b]">No destinations found.</div>}
        </div>
      </section>
    </>
  );
}
